import React from 'react'
import { Col, Row } from 'antd'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import { Input, SelectResource } from 'src/components/Formik'
import { Title } from 'src/components/Ant'

import { InitialValues } from '../initial-values'

interface Props {
  formikProps: FormikProps<InitialValues>
}

export default function UserInfo({ formikProps }: Props) {
  const { t } = useTranslation()
  return (
    <>
      <Title level={4}>{t('web.user.common.additional_information')}</Title>
      <Row gutter={24}>
        <Col span={12}>
          <Input
            formikProps={formikProps}
            label="web.user.common.code.title"
            name="code"
            required={false}
          />
        </Col>
        <Col span={12}>
          <Input
            formikProps={formikProps}
            label="web.user.common.position.title"
            name="position"
            required={false}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={8}>
          <SelectResource
            defaultActiveFirstOption={false}
            formikProps={formikProps}
            keyLabel="name"
            keyValue="cost_center_id"
            label="web.resources.cost-centers.title"
            name="cost_center_id"
            required={false}
            resource="cost_centers"
          />
        </Col>
        <Col span={8}>
          <SelectResource
            defaultActiveFirstOption={false}
            formikProps={formikProps}
            keyLabel="name"
            keyValue="reference_id"
            label="web.resources.references.title"
            name="reference_id"
            required={false}
            resource="references"
          />
        </Col>
        <Col span={8}>
          <SelectResource
            defaultActiveFirstOption={false}
            formikProps={formikProps}
            keyLabel="name"
            keyValue="contract_id"
            label="web.assignment.sharing.form.contract.title"
            name="contract_id"
            placeholder="web.assignment.sharing.form.contract.placeholder"
            required={false}
            resource="contracts"
          />
        </Col>
      </Row>
    </>
  )
}
